// extracted by mini-css-extract-plugin
export default {"container":"videoSwitcher_container__IaN0A","switch":"videoSwitcher_switch__BP3pA"};